import React, { memo } from "react";
import { useSelector } from "react-redux";
import * as AllFrames from "./svg";
import useFrames from "../../../../hooks/useFrames";

function QrFrameWrapper({
  frame,
  frameColor,
  isTransformFrameWithTextTemplate,
  children,
}) {
  const { frameTextToggle } = useSelector((state) => ({
    frameTextToggle: !!state.qrFrames.frameTextToggle,
  }));
  const isTransform =
    typeof isTransformFrameWithTextTemplate !== "undefined"
      ? isTransformFrameWithTextTemplate
      : frameTextToggle;
  const { frameConfigs } = useFrames();

  const selectedFrame = frameConfigs.find((item) => item.name === frame);
  const Component = AllFrames[selectedFrame.fileName];

  return (
    <Component
      fill={frameColor}
      frameTextToggle={
        isTransform
          ? selectedFrame.transformFameBoxWithText
          : selectedFrame.transformFameBox
      }
    >
      {children}
    </Component>
  );
}

export default QrFrameWrapper = memo(QrFrameWrapper);
